import React from 'react'
import { STATICS } from 'statics'
import './style.scss'

export function SuccessMessage() {
  return (
    <div id='container-message'>
      <div className='icon-holder'>
        <STATICS.CELEBRATION />
      </div>
      <span className='title'>Deu tudo certo!</span>
      <span className='description'>
        Sua solicitação foi concluída com sucesso.
        <br /> Veja o que foi assinado e ative seu produto.
      </span>
    </div>
  )
}
